export const modelSharePlatformEN = {
  title: "FrontFire Model Matrix",
  subtitle: "FrontFire Model library openedto the public",
  feature: {
    title: "Platform Features",
    list: [
      {
        title: "Comprehensiveness",
        content:
          "Includes AI and spatial intelligent agent component models of varying precision levels from L0 to L4",
      },
      {
        title: "High Scalability",
        content:
          "An open sharing platform accessible for transactions across all sectors",
      },
    ],
  },
  matrix: {
    title: "FrontFire Model Matrix ",
    subtitle:
      "A Publicly Accessible Platform for Refined Categorized Model Library ",
  },
  // 重器矩阵
  tableData: [
    {
      col0: "Refinement Level",
      col1: "Traffic Flow",
      col2: "Dynamics",
      col3: "Radar",
      col4: "Lidar",
      col5: "USS",
      col6: "Sonar",
      col7: "Camera",
      col8: "Infrared Camera",
      col9: "GNSS",
      col10: "IMU",
      col11: "V2X",
    },
    {
      col0: "L0",
      col1: "OpenScenario Scene Reconstruction PDOpsTrBuild",
      col2: "PD Effect-level dynamics model PDDynaBS",
      col3: "PD Object-level ideal sensor model group iSens4Obj",
      col4: "PD Object-level ideal sensor model group iSens4Obj",
      col5: "PD Point cloud-level ideal sensor model group iSens4Pcd",
      col6: "PD Point cloud-level ideal sensor model group iSens4Pcd",
      col7: "PD Object-level ideal sensor model group iSens4Obj",
      col8: "PD Object-level ideal sensor model group iSens4Obj",
      col9: "PD Main Vehicle Position Ideal Sensing Model group iSens4Ego",
      col10: "PD Main Vehicle Position Ideal Sensing Model group iSens4Ego",
      col11: "PD Object-level ideal sensor model group iSens4Obj",
    },
    {
      col0: "L1",
      col1: "PD reflexive random traffic generator PDRefTrBuild",
      col2: "PD Bicycle dynamics model PDDynaBM",
      col3: "PD Object-level random sensor model group StSens4Obj",
      col4: "PD Point cloud level random sensor model group iSens4Pcd",
      col5: "PD Point cloud-level random sensor model group iSens4Pcd",
      col6: "PD Point cloud-level random sensor model group iSens4Pcd",
      col7: "PD Object-level random sensor model group StSens4Obj",
      col8: "PD Object-level random sensor model group StSens4Obj",
      col9: "PD Main Vehicle Position random Sensing Model group StSens4Ego",
      col10: "PD Main Vehicle Position random Sensing Model group StSens4Ego",
      col11: "PD Object-level random sensor model group StSens4Obj",
    },
    {
      col0: "L2",
      col1: "PD traffic generator with lateral and longitudinal control PDCtrTrBuild",
      col2: "PD 14 DOF dynamics model PDDyna14",
      col3: "PD Phenomenon-based sensor model group PhenoSens",
      col4: "PD Phenomenon-based sensor model group PhenoSens",
      col5: "PD Phenomenon-based sensor model group PhenoSens",
      col6: "PD Phenomenon-based sensor model group PhenoSens",
      col7: "PD Phenomenon-based sensor model group PhenoSens",
      col8: "PD Phenomenon-based sensor model group PhenoSens",
      col9: "PD Phenomenon-based modeling group for main vehicle position PhenoSens4Ego",
      col10: "",
      col11: "PD Phenomenon-based sensor model group PhenoSens",
    },
    {
      col0: "L3",
      col1: "PD AI-based traffic decision generator PDAITrBuild",
      col2: "PD 30 DOF dynamics model PDDyna30",
      col3: "PD Semi-Physical Sensor Model group RTPhyxSens",
      col4: "PD Semi-Physical Sensor Model group RTPhyxSens",
      col5: "PD Semi-Physical Sensor Model group RTPhyxSens",
      col6: "PD Semi-Physical Sensor Model group RTPhyxSens",
      col7: "PD Semi-Physical Sensor Model group RTPhyxSens",
      col8: "PD Semi-Physical Sensor Model group RTPhyxSens",
      col9: "",
      col10: "",
      col11: "PD Semi-Physical Sensor Model group RTPhyxSens",
    },
    {
      col0: "L4",
      col1: "",
      col2: "PDCtrTrBuild Vehicle Component Model Library+PDDyna30",
      col3: "PD Full physical sensor model group PRPhyxSens",
      col4: "PD Full physical sensor model group PRPhyxSens",
      col5: "",
      col6: "",
      col7: "PD Full physical sensor model group PRPhyxSens",
      col8: "PD Full physical sensor model group PRPhyxSens",
      col9: "",
      col10: "",
      col11: "PD Full physical sensor model group PRPhyxSens",
    },
  ],
};
export const modelSharePlatformCN = {
  title: "重器矩阵 模型共享平台",
  subtitle: "面向全社会开放的模型库",
  feature: {
    title: "平台特点",
    list: [
      {
        title: "全面性",
        content: "包含从L0-L4不同精度的多种智能体搭载的丰富元器件模型",
      },
      {
        title: "高拓展性",
        content: "面向全社会交易的开放共享平台",
      },
    ],
  },
  matrix: {
    title: "重器矩阵",
    subtitle: "面向全社会开放的模型库细化分类平台",
  },
  // 重器矩阵
  tableData: [
    {
      col0: "Refinement Level",
      col1: "Traffic Flow",
      col2: "Dynamics",
      col3: "Radar",
      col4: "Lidar",
      col5: "USS",
      col6: "Sonar",
      col7: "Camera",
      col8: "Infrared Camera",
      col9: "GNSS",
      col10: "IMU",
      col11: "V2X",
    },
    {
      col0: "L0",
      col1: "OpenScenario场景还原 PDOpsTrBuild",
      col2: "PD效果级动力学模型 PDDynaBS",
      col3: "PD对象级理想传感器模型组 iSens4Obj",
      col4: "PD对象级理想传感器模型组 iSens4Obj",
      col5: "PD点云级理想传感器模型组 iSens4Pcd",
      col6: "PD点云级理想传感器模型组 iSens4Pcd",
      col7: "PD对象级理想传感器模型组 iSens4Obj",
      col8: "PD对象级理想传感器模型组 iSens4Obj",
      col9: "PD主车位姿理想传感模型组iSens4Ego",
      col10: "PD主车位姿理想传感模型组 iSens4Ego",
      col11: "PD对象级理想传感器模型组 iSens4Obj",
    },
    {
      col0: "L1",
      col1: "PD自反式随机交通生成器 PDRefTrBuild",
      col2: "PD单车动力学模型 PDDynaBM",
      col3: "PD对象级随机传感器模型组 StSens4Obj",
      col4: "PD点云级随机传感器模型组 iSens4Pcd",
      col5: "PD点云级随机传感器模型组 iSens4Pcd",
      col6: "PD点云级随机传感器模型组 iSens4Pcd",
      col7: "PD对象级随机传感器模型组 StSens4Obj",
      col8: "PD对象级随机传感器模型组 StSens4Obj",
      col9: "PD主车位姿随机传感模型组 StSens4Ego",
      col10: "PD主车位姿随机传感模型组 StSens4Ego",
      col11: "PD对象级随机传感器模型组 StSens4Obj",
    },
    {
      col0: "L2",
      col1: "PD纵横向控制交通生成器 PDCtrTrBuild",
      col2: "PD14自由度动力学模型 PDDyna14",
      col3: "PD基于现象的传感器模型组 PhenoSens",
      col4: "PD基于现象的传感器模型组 PhenoSens",
      col5: "PD基于现象的传感器模型组 PhenoSens",
      col6: "PD基于现象的传感器模型组 PhenoSens",
      col7: "PD基于现象的传感器模型组 PhenoSens",
      col8: "PD基于现象的传感器模型组 PhenoSens",
      col9: "PD基现象的主车位姿模型组 PhenoSens4Ego",
      col10: "",
      col11: "PD基于现象的传感器模型组 PhenoSens",
    },
    {
      col0: "L3",
      col1: "PD基于AI的交通决策生成器 PDAITrBuild",
      col2: "PD30自由度动力学模型 PDDyna30",
      col3: "PD半物理传感器模型组 RTPhyxSens",
      col4: "PD半物理传感器模型组 RTPhyxSens",
      col5: "PD半物理传感器模型组 RTPhyxSens",
      col6: "PD半物理传感器模型组 RTPhyxSens",
      col7: "PD半物理传感器模型组 RTPhyxSens",
      col8: "PD半物理传感器模型组 RTPhyxSens",
      col9: "",
      col10: "",
      col11: "PD半物理传感器模型组 RTPhyxSens",
    },
    {
      col0: "L4",
      col1: "",
      col2: "车辆组件模型库+PDDyna30",
      col3: "PD全物理传感器模型组 PRPhyxSens",
      col4: "PD全物理传感器模型组 PRPhyxSens",
      col5: "",
      col6: "",
      col7: "PD全物理传感器模型组 PRPhyxSens",
      col8: "PD全物理传感器模型组 PRPhyxSens",
      col9: "",
      col10: "",
      col11: "PD全物理传感器模型组 PRPhyxSens",
    },
  ],
};
